<template>
  <div>
    <video ref="videoPlayer" class="video-js" style="width: 1000px; height:500px"></video>
  </div>
</template>

<script>
import videojs from  'video.js/dist/video.min'
import 'video.js/dist/video-js.min.css'
import video_zhCN from 'video.js/dist/lang/zh-CN.json'
import { ref, onBeforeUnmount, onMounted } from "vue"
export default {
  name: "VideoPlayer",
  props: ['options'],
  
  
  setup(props) {
    let player = ref()
    let videoPlayer = ref()
    let options = ref(props.options)
    onMounted(() => {

      videojs.addLanguage('zh-CN', video_zhCN);
      console.log(options.value)
      player.value = videojs(videoPlayer.value, options.value)
    })
    

    onBeforeUnmount(() => {
      if (player.value) {
        player.value.dispose();
      }
    })
    return {
      player,
      videoPlayer,
      options,
    };
  }
  
  
};
</script>